<template>
    <div id="browse">
        <Navi currentPage="7"></Navi>
        <div class="body_container main_context">
            <div class="breadcrumb_con">
                <el-breadcrumb separator="/" class="breadcrumb">
                    <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
                    <el-breadcrumb-item>Contact</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="main_div">
                <div class="pcga-doc-h">
                    Contact us
                </div>
                <div class="pcga-doc-p">
                    PCGA is is developed by the Precision Medicine Genomic Laboratory of Sun Yat-sen University. If you have any questions, please contact us on 
                    <a href="mailto:limiaoxin@mail.sysu.edu.cn">limiaoxin@mail.sysu.edu.cn</a> (Prof. Li).
                </div>
                <div class="pcga-doc-h">
                    Feedback
                </div>
                <div class="pcga-doc-p">
                    If you have any suggestions for our web server, please let us know via the feedback box below. We would love to hear from you!
                </div>
                <div class="box">
                    <el-form ref="ruleForm" :model="form" label-width="150px" :rules="rules">
                        <el-form-item label="Type">
                            <el-select v-model="form.type" placeholder="">
                            <el-option label="Suggestion" value="suggestion"></el-option>
                            <el-option label="Report bug" value="bug"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Result URL (optional)" v-if="form.type=='bug'">
                            <el-input v-model="form.url" placeholder="please input your result URL" maxlength="100" show-word-limit></el-input>
                        </el-form-item>
                        <el-form-item label="Description" prop="desc">
                            <el-input type="textarea"  v-model="form.desc" :placeholder="form.type=='bug'?'Please descript your question':'Please input your suggestion'" rows=6  maxlength="500" show-word-limit></el-input>
                        </el-form-item>
                          <el-form-item label="E-mail (optional)" >
                            <el-input v-model="form.email"  maxlength="100" show-word-limit></el-input>
                        </el-form-item>
                          <el-form-item label="">
                           <el-button type="primary" icon="el-icon-submit" @click="submitFeedback('ruleForm')">Submit</el-button>
                           <el-button type="danger" icon="el-icon-submit" @click="reset">Reset</el-button>
                        </el-form-item>
                        
                    </el-form>
                    
                </div>
            </div>
        </div>

        <!-- <Doc :paras="paras"></Doc> -->

        <Footer></Footer>
    </div>
</template>

<script>
import Navi from '@/components/navigate.vue'
import Footer from '@/components/footer.vue'
import axios from "axios/dist/axios.min";
import { api_dir } from "@/bus.js";

export default {
    name: 'browse',
    components: { Navi, Footer },
    data: function () {
        return {
            form:{
                type:'suggestion',
                desc:'',
                email:'',
                url:''
            },
            rules: {
                desc: [{ required: true, message: 'Please input text', trigger: 'blur' },
                ]
            },
        }
    },
    mounted: function () {

    },
    methods: {
        submitFeedback(formName){
        var _this=this
        this.$refs[formName].validate((valid) => {
          if (valid) {
            axios.get(api_dir + "/api.php?action=feedback",{
                params:_this.form
            }).then(function(response){
                var res = JSON.parse(JSON.stringify(response.data));
                if(res.error_code==0){
                    _this.$message({
                    message: 'Submitted successfully! Thanks for your feedback',
                    type: 'success'
                    });
                }else{
                   _this.$message({
                    message: 'Submission Failed! Please retry',
                    type: 'error'
                    });
                }
            }).catch(function(e){
                    _this.$message({
                    message: 'Submission Failed! Please retry',
                    type: 'error'
                    });
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
        },
        reset(){
            this.form.desc='';
            this.form.email='';
            this.form.url='';
        }
    }
}
</script>



<style>
.el-collapse-item__header{
    font-size: 16px;
    font-weight: 600;
}
.box{
    width: 800px;
    margin: 60px 0px 40px 0px;
}


.main_div{
    margin-left: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/contact.vue